module.exports = __webpack_public_path__ + "static/media/algorithm.303ed122.png";